module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAAAAXNSR0IArs4c6QAAASlJREFUSEut1r0uBUEYgOH3CIlEIZFQI6JUi1Kn4RYU4ioQ4gYUfkoVJVFqFC5ALRG3IHEFLxPjmDPO2bO7s1tudp+d72e+2R4Fl7oLnAEXvbaOegCcxvc/GkPqZFgBsJ8s4rMRpM4AN8BOFkl9SF0A7oGNIemoB6lLwBOwOCKn4yF1DXgGZisKUw2pm8AjEBJcdY2GYo9c12yP/5A6ARx+A8c1kfDYIKROAZfAXgNkEFKngTtgqyHyB8VGewFWWyA/kDoPvAJzLZE+9AasFCB96B1Y7gLqJrSwkk6S/RtSJ+VPsPKGTLDyLZJWrnjTZlj5GElCLR9sCVY+ahMsDP8HYL318E+wcBzdAtsZNn7451+Pw++86IDMKnoEnMR7zY/sIb0WfiKuvgAFXJMLCvkPDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/trusteeCouncil/images/left.png
// module id = J7ge
// module chunks = 0